<div class="eone-capacity-expansion-dialog-plugin" hive-root>
    <div class="eone-capacity-expansion-dialog-plugin__title-section">
        <div class="eone-capacity-expansion-dialog-plugin__title">
            Recommendation Details for {{ renderInfo().targetName }}
        </div>
        @if (renderInfo().asOfTime) {
            <div class="eone-capacity-expansion-dialog-plugin__generated">
                Generated {{ renderInfo().asOfTime | date: 'mediumDate' }} — all data reflects this date
            </div>
        }
    </div>
    <div class="eone-capacity-expansion-dialog-plugin__header">
        <div class="eone-capacity-expansion-dialog-plugin__sub-header">
            Service Tier: {{ renderInfo().serviceTier }}
        </div>
        <div class="eone-capacity-expansion-dialog-plugin__headline">
            Expand reserved capacity from {{ renderInfo().currentReserveTib }} TiB to
            <span class="eone-capacity-expansion-dialog-plugin__improved">
                <hive-icon-component [icon]="faArrowUp" size="small" />
                {{ renderInfo().recommendedReserveTib }} TiB
            </span>
        </div>
    </div>
    <div class="eone-capacity-expansion-dialog-plugin__body">
        <table class="eone-capacity-expansion-dialog-plugin__table">
            <thead>
                <tr>
                    <th></th>
                    <th>Capacity (Current)</th>
                    <th class="eone-capacity-expansion-dialog-plugin__recommended-col">Capacity (Recommended)</th>
                </tr>
            </thead>
            <tbody>
                @for (row of renderInfo().comparisonRows; track row.label) {
                    <tr>
                        <td>{{ row.label }}</td>
                        <td>
                            @if (row.currentValue?.isWarning) {
                                <span class="eone-capacity-expansion-dialog-plugin__warning">{{
                                    row.currentValue.text
                                }}</span>
                            } @else {
                                {{ row.currentValue?.text }}
                            }
                        </td>
                        <td>
                            @if (row.recommendedValue?.text) {
                                @if (row.recommendedValue.isImproved === false) {
                                    {{ row.recommendedValue.text }}
                                } @else {
                                    <span class="eone-capacity-expansion-dialog-plugin__improved">
                                        <hive-icon-component
                                            [icon]="
                                                row.recommendedValue.arrowDirection === 'down' ? faArrowDown : faArrowUp
                                            "
                                            size="small"
                                        />
                                        {{ row.recommendedValue.text }}
                                    </span>
                                }
                            } @else {
                                —
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </table>
        <div class="eone-capacity-expansion-dialog-plugin__chart">
            <div class="eone-capacity-expansion-dialog-plugin__chart-header">
                Capacity is projected to reach {{ renderInfo().projectedUsagePercent }}% of reserve in
                {{ renderInfo().thresholdHorizonDays }} days.
                <a hive-link (click)="toggleChart($event)">
                    @if (showChart()) {
                        Hide Chart
                    } @else {
                        Why this is recommended to me?
                    }
                </a>
            </div>
            @if (showChart()) {
                <div #chartContainer class="eone-capacity-expansion-dialog-plugin__chart-container"></div>
                <div class="eone-capacity-expansion-dialog-plugin__chart-legend">
                    <span class="eone-capacity-expansion-dialog-plugin__chart-legend-swatch"></span>
                    Capacity exceeding current reserve
                </div>
            }
        </div>
    </div>
    <footer class="eone-capacity-expansion-dialog-plugin__footer">
        @if (renderInfo().allowDismiss) {
            <hive-button
                label="Dismiss Recommendation"
                emphasis="secondary"
                [disabled]="!renderInfo().allowDismiss() || renderInfo().actionInProgress()"
                hiveTooltip
                [hiveTooltipDescription]="renderInfo().allowDismiss() ? '' : 'Operation not permitted'"
                (click)="handleActionEvent(RecommendationActionEvent.DISMISS)"
            ></hive-button>
        }
        <hive-button
            label="Cancel"
            emphasis="secondary"
            [disabled]="renderInfo().actionInProgress()"
            (click)="handleActionEvent(RecommendationActionEvent.CANCEL)"
        ></hive-button>
        <hive-button
            label="Request Quote"
            emphasis="primary"
            [isLoading]="renderInfo().actionInProgress()"
            [disabled]="!renderInfo().allowRequestQuote() || renderInfo().actionInProgress()"
            hiveTooltip
            [hiveTooltipDescription]="renderInfo().allowRequestQuote() ? '' : 'Operation not permitted'"
            (click)="handleActionEvent(RecommendationActionEvent.REQUEST_QUOTE)"
        ></hive-button>
    </footer>
</div>
